"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var StyledBullet = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\theight: 15px;\n\twidth: 15px;\n\tbackground-color: #333;\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tmargin: 0 2px;\n\n\t", ";\n"], ["\n\tcursor: pointer;\n\theight: 15px;\n\twidth: 15px;\n\tbackground-color: #333;\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tmargin: 0 2px;\n\n\t", ";\n"])), function (_a) {
  var active = _a.active;
  return active ? 'opacity: 0.5' : '';
});

var Bullet = function Bullet(_a) {
  var
  /* eslint-disable react/prop-types */
  index = _a.index,
      BulletComponent = _a.BulletComponent,
      setSlide = _a.setSlide,
      activeIndex = _a.activeIndex,
      bulletStyle = _a.bulletStyle
  /* eslint-enable react/prop-types */
  ;

  var updateSlide = function updateSlide() {
    setSlide(index);
  };

  if (BulletComponent) {
    return react_1.default.createElement(BulletComponent, {
      key: index,
      isActive: index === activeIndex,
      onClick: updateSlide
    });
  }

  return react_1.default.createElement(StyledBullet, {
    key: index,
    active: index === activeIndex,
    style: bulletStyle,
    onClick: updateSlide
  });
};

Bullet.defaultProps = {
  BulletComponent: undefined,
  bulletStyle: {}
};
exports.default = Bullet;
var templateObject_1;